"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var banali_react_leaflet_1 = require("banali-react-leaflet");
var GoogleGeocoding_1 = __importDefault(require("../../../../constants/GoogleGeocoding"));
var mapHelpers_1 = require("../../../../helpers/mapHelpers");
var lodash_1 = require("lodash");
var usePrevious_1 = require("../../../../hooks/usePrevious");
var react_redux_1 = require("react-redux");
var searchParamsSlice_1 = require("../../../../features/searchParams/searchParamsSlice");
var Choropleth = function (_a) {
    var state = _a.state, stateQuery = _a.stateQuery, additionalQuery = _a.additionalQuery, query = _a.query, setMapQuery = _a.setMapQuery, stateFilterIsSelected = _a.stateFilterIsSelected, filterAreRemoved = _a.filterAreRemoved, isAddressPickerSelected = _a.isAddressPickerSelected;
    var map = banali_react_leaflet_1.useMap();
    var previousStateFilterIsSelected = usePrevious_1.usePrevious(stateFilterIsSelected);
    var customPlace = react_redux_1.useSelector(searchParamsSlice_1.useSelectCustomPlace);
    react_1.useEffect(function () {
        map.fitBounds([GoogleGeocoding_1.default.MAP.DEFAULT_CENTER]);
        map.setZoom(GoogleGeocoding_1.default.MAP.ZOOM);
    }, []);
    banali_react_leaflet_1.useMapEvents({
        dragend: function () {
            setMapQuery({
                south: map.getBounds().getSouth(),
                west: map.getBounds().getWest(),
                east: map.getBounds().getEast(),
                north: map.getBounds().getNorth(),
            }, map.getZoom());
        },
    });
    react_1.useEffect(function () {
        var _a;
        if ((_a = stateQuery === null || stateQuery === void 0 ? void 0 : stateQuery.state) === null || _a === void 0 ? void 0 : _a.length) {
            var unionBounds_1 = [];
            state.forEach(function (stateData) {
                if (stateQuery.state.includes(String(stateData.govId))) {
                    var _a = mapHelpers_1.getBoundsByCompassDirections({
                        south: Number(stateData.boundingbox[0]),
                        north: Number(stateData.boundingbox[1]),
                        west: Number(stateData.boundingbox[2]),
                        east: Number(stateData.boundingbox[3]),
                    }), sw = _a.sw, ne = _a.ne;
                    sw && ne && unionBounds_1.push(lodash_1.union([sw], [ne]));
                }
            });
            map &&
                unionBounds_1.length &&
                map.fitBounds(unionBounds_1.map(function (item) { return [
                    {
                        lat: item[0].lat(),
                        lng: item[0].lng(),
                    },
                    {
                        lat: item[1].lat(),
                        lng: item[1].lng(),
                    },
                ]; }));
        }
    }, [stateQuery.state, state]);
    react_1.useEffect(function () {
        if (additionalQuery.viewBox) {
            var _a = mapHelpers_1.getBoundsByCompassDirections(additionalQuery.viewBox), sw = _a.sw, ne = _a.ne;
            var bounds = lodash_1.union([sw], [ne]);
            fitMapBounds(bounds);
        }
    }, []);
    react_1.useEffect(function () {
        var _a;
        if (!((_a = additionalQuery.customViewBox) === null || _a === void 0 ? void 0 : _a.length) && filterAreRemoved) {
            var _b = mapHelpers_1.getBoundsByCompassDirections(additionalQuery.viewBox), sw = _b.sw, ne = _b.ne;
            var bounds = lodash_1.union([sw], [ne]);
            fitMapBounds(bounds);
        }
    }, [
        additionalQuery.page,
        additionalQuery.sortBy,
        additionalQuery.customViewBox,
        query,
    ]);
    react_1.useEffect(function () {
        if (additionalQuery.viewBox &&
            !stateFilterIsSelected &&
            previousStateFilterIsSelected) {
            var _a = mapHelpers_1.getBoundsByCompassDirections(GoogleGeocoding_1.default.MAP.ARMENIAN_COORDINATES), sw = _a.sw, ne = _a.ne;
            var bounds = lodash_1.union([sw], [ne]);
            fitMapBounds(bounds);
            map.setZoom(GoogleGeocoding_1.default.MAP.ZOOM);
        }
    }, [
        stateFilterIsSelected,
        additionalQuery.viewBox,
        previousStateFilterIsSelected,
    ]);
    react_1.useEffect(function () {
        if (!!customPlace) {
            map.setView([customPlace.center.lat, customPlace.center.lng], 17);
        }
    }, [customPlace, isAddressPickerSelected]);
    var fitMapBounds = function (bounds) {
        map.fitBounds([
            {
                lat: bounds[0].lat(),
                lng: bounds[0].lng(),
            },
            {
                lat: bounds[1].lat(),
                lng: bounds[1].lng(),
            },
        ]);
    };
    return null;
};
exports.default = Choropleth;
